"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardValidator = function (number) {
    var nCheck = 0;
    var nDigit = 0;
    var bEven = false;
    var value = number.replace(/\D/g, "");
    for (var n = value.length - 1; n >= 0; n--) {
        nDigit = parseInt(value.charAt(n), 10);
        if (bEven) {
            nDigit *= 2;
            if (nDigit > 9)
                nDigit -= 9;
        }
        nCheck += nDigit;
        bEven = !bEven;
    }
    return nCheck % 10 === 0;
};
exports.CardValidator = CardValidator;
//# sourceMappingURL=card-validator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/card-validator.js
// module id = 879
// module chunks = 3